import React from 'react';

import s from './InfoCard.module.scss';

const InfoCard = ({ children }) => <div className={s['info-card']}>{children}</div>;

export default InfoCard;
